import { useEffect } from 'react'
import {
  loadClientPortalPayments,
  loadCommercialCase,
  submitCommercialRequest,
  uploadClientPortalPaymentProof,
  uploadReservationProof,
  type CommercialRequestPayload,
} from './service'

const value = (form: FormData, key: string) => String(form.get(key) ?? '')
const emit = (name: string, detail: unknown) => window.dispatchEvent(new CustomEvent(name, { detail }))
const message = (error: unknown, fallback: string) => error instanceof Error ? error.message : fallback

export function CommercialRequestBridge() {
  useEffect(() => {
    const submit = () => {
      const element = document.getElementById('kycForm')
      if (!(element instanceof HTMLFormElement)) return
      const form = new FormData(element)
      if (value(form, 'website')) return emit('siga:commercial-request-result', { ok: true, caseCode: 'WEB-RECIBIDO' })
      const payload: CommercialRequestPayload = {
        projectId: value(form,'project_id'), projectUnitId: value(form,'project_unit_id'),
        firstName: value(form,'first_name'), lastName: value(form,'last_name'),
        documentType: value(form,'document_type') as CommercialRequestPayload['documentType'], documentNumber: value(form,'document_number'),
        nationality: value(form,'nationality'), maritalStatus: value(form,'marital_status') as CommercialRequestPayload['maritalStatus'],
        email: value(form,'email'), phone: value(form,'phone'), whatsapp: value(form,'whatsapp'),
        city: value(form,'city'), address: value(form,'address'), employmentStatus: value(form,'employment_status'),
        occupationCompany: value(form,'occupation_company'), incomeRange: value(form,'income_range'), fundsSource: value(form,'funds_source'),
        brokerReference: value(form,'broker_reference'), consent: form.get('consent') === 'on',
      }
      void submitCommercialRequest(payload)
        .then(result => emit('siga:commercial-request-result', { ok: true, ...result }))
        .catch(error => emit('siga:commercial-request-result', { ok: false, message: message(error,'No fue posible enviar la solicitud.') }))
    }

    const loadCase = (event: Event) => {
      const detail = (event as CustomEvent).detail ?? {}
      void loadCommercialCase(String(detail.caseCode ?? ''), String(detail.accessToken ?? ''))
        .then(status => emit('siga:case-status-result', { ok: true, status }))
        .catch(error => emit('siga:case-status-result', { ok: false, message: message(error,'No se pudo consultar el caso.') }))
    }
    const uploadReservation = (event: Event) => {
      const detail = (event as CustomEvent).detail ?? {}
      void uploadReservationProof(detail)
        .then(result => emit('siga:reservation-proof-result', { ok: true, result }))
        .catch(error => emit('siga:reservation-proof-result', { ok: false, message: message(error,'No se pudo enviar el comprobante.') }))
    }
    const loadPayments = (event: Event) => {
      const detail = (event as CustomEvent).detail ?? {}
      void loadClientPortalPayments(String(detail.caseCode ?? ''), String(detail.accessToken ?? ''))
        .then(data => emit('siga:client-payments-result', { ok: true, data }))
        .catch(error => emit('siga:client-payments-result', { ok: false, message: message(error,'No se pudo cargar el plan.') }))
    }
    const uploadClientPayment = (event: Event) => {
      const detail = (event as CustomEvent).detail ?? {}
      void uploadClientPortalPaymentProof(detail)
        .then(result => emit('siga:client-payment-proof-result', { ok: true, result }))
        .catch(error => emit('siga:client-payment-proof-result', { ok: false, message: message(error,'No se pudo enviar el comprobante.') }))
    }

    window.addEventListener('siga:commercial-request-submit', submit)
    window.addEventListener('siga:case-status-request', loadCase)
    window.addEventListener('siga:reservation-proof-submit', uploadReservation)
    window.addEventListener('siga:client-payments-request', loadPayments)
    window.addEventListener('siga:client-payment-proof-submit', uploadClientPayment)
    return () => {
      window.removeEventListener('siga:commercial-request-submit', submit)
      window.removeEventListener('siga:case-status-request', loadCase)
      window.removeEventListener('siga:reservation-proof-submit', uploadReservation)
      window.removeEventListener('siga:client-payments-request', loadPayments)
      window.removeEventListener('siga:client-payment-proof-submit', uploadClientPayment)
    }
  }, [])
  return null
}
